import {
    Button,
    Flex,
    Modal,
    ModalBody,
    ModalCloseButton,
    ModalContent,
    ModalHeader,
    ModalOverlay,
    Text
} from '@chakra-ui/react';

import React from 'react';

function ConfirmDeleteModal({ copy, isModalOpen, onCancel, onConfirm }) {


    return (
        <Modal size={'lg'} isCentered={true} isOpen={isModalOpen} onClose={onCancel}>
            <ModalOverlay />
            <ModalContent>
                <ModalHeader textAlign={'center'}>Delete</ModalHeader>
                <ModalCloseButton />
                <ModalBody textAlign={'center'}>
                    <Text>{copy}</Text>

                    <Flex gap={'20px'} mb={'20px'} mt={'40px'} align={'center'} justify={'center'}>
                        <Button
                            colorScheme="gray"
                            variant="solid"
                            onClick={onCancel}
                            size={'sm'}
                        >
                            Cancel</Button>
                        <Button colorScheme='red' onClick={onConfirm} size={'sm'} >Confirm</Button>
                    </Flex>
                </ModalBody>
            </ModalContent>
        </Modal>
    )
}

export default ConfirmDeleteModal